import React from "react";

import { getServiceUri } from "../../auto/js/metadata";
import { rest, t } from "../../auto/js/services";
import { OPEN_CREATE_OR_SEARCH, PRINT_EVENT } from "../../auto/js/events/Gui";
import TemplateComponent from "react-mustache-template-component";
import { createFormComponent } from "../../auto/js/widgets";
import { dto2form, recordsFields } from "../../main/js/forms/records/NewRecordsForm";
import { servicesRest } from "./services/ServicesRestClient";
import { record } from "./Record";
import { whoami } from "../../auto/js/users/UserInfo";
import { mapNnFieldto2ListView } from "./Widgets/WidgetsFilters";
import { STATUS_REJECTED, STATUS_SIGNED } from "../../auto/js/metadata/Status";

const gender = {1:"MALE", 2:"FEMALE"};
const maritalStatus = {1:"SINGLE", 2:"MARRIED", 3:"DIVORCED", 4:"WIDOWED"};

export const loadPersonData = async (id) => {
    return  rest.read("records", id, getDjServicesUrl()).then(response => {
        if (response.status)
            return undefined;
        else {
            response['image'] = { x: 0.5, y: 0.5, scale: 1, rotate: 0, url: '/public/avatar.png', isEmpty: true };
            return response;
        }
    })
}

export const getRecordsOptions = async (filter) => {
    let recordFilter = {and: false, limit: 20, fuzziness: "AUTO"};
    if (filter) {
        recordFilter['identity-record-document-dto'] = {recordStatusList: ["ACTIVE"]};
        recordFilter['identity-record-document-dto'].lastname = filter;
        recordFilter['identity-record-document-dto'].othernames = filter;
        recordFilter['identity-record-document-dto'].firstname = filter;
        return rest.searchDocument('identity-record', recordFilter, getDjServicesUrl()).then(response => {
            const result = response.reduce((acc, item) => {
                let firstName = (item.firstname !== null)?item.firstname + ' ':'';
                let othernames = (item.othernames !== null)?item.othernames + ' ' :'';
                let lastname = (item.lastname !== null)?item.lastname:'';
                acc[item.id] = firstName + othernames + lastname;
                return acc;
            }, {});
            return result
        })
    }
    else
        return {}
}
export function getDjServicesUrl() {
    return 'https://khaledanconnect.kd.chahinehamila.com/api/';
}

const addRecordCallback = (id, addEntry) => {
    rest.read('records', id, getDjServicesUrl()).then(response => {
        response.label =   `${(response.firstname)?response.firstname:''} ${(response.othernames)?response.othernames:''} ${(response.lastname)?response.lastname:''}`;
        addEntry(response);
    })
}


export const createRecord = (data, addEntry, gui, onCancel) => {
    const c = (id) => {addRecordCallback(id, addEntry)};
    let names = record.transformRecordNames(data);
    let dto = {firstname: names.firstname, lastname: names.lastname, othernames: names.othernames, id: null}
    OPEN_CREATE_OR_SEARCH.publish({callback: c, data: dto, cancel: onCancel})
}

export const readRecord = (gui) => (id) => {
    let RecordsForm = createFormComponent(recordsFields);
    gui.openSidePanel(<RecordsForm loadData={async () => loadRecordFormData(id)} id={id} buttons={() => null} />, t`Person`)
}

const loadRecordFormData = async (id) => {
    let token = await rest.getToken(getServiceUri() + 'token/get-auth-code');
	return await servicesRest.read('records', id).then(response => {
		let form = dto2form(response, token);
        form['image'] = { x: 0.5, y: 0.5, scale: 1, rotate: 0, url: '/public/avatar.png', isEmpty: true };
		return form;
	})
}

export const loadSubstitut = async (id) => {
    return rest.read("user-entity/legacy-read", id).then(response => {
        if (response.status)
            return undefined;
        else {
            return response
        }
    })
}

export const Section = ({name}) => {
	return (
		<>
		<div class="col-md-12 sectiontitle">
			<h2 style={{ display: "inline" }}>{t(name)}</h2>
		</div>
		</>
	)
}

export const printTemplate = (data) => () => {
	PRINT_EVENT.publish({
		content: <TemplateComponent template={data.template} data={data.templateData} />
	})
}

export const capitalizeFirstChar = (name) => {
    if (!name || typeof name !== 'string') {
        return '';
    }
    return name.charAt(0).toUpperCase() + name.slice(1);
}

export const filterListViews = (rows, columns, displayFilters) => {
    const newRows = [];
    for (let i in rows) {
        let row = rows[i];
        let newRow = {}
        for (let j in columns) {
            let c = columns[j].field;
            if (displayFilters[c])
                newRow[c] = displayFilters[c](row[c]);
            else
                newRow[c] = row[c];
        }
        newRows.push(newRow);
    }
    return newRows;
}

export const filterObject = (data, fieldFilters) => {
    let response = {};
    let fields = Object.keys(data);
    for (let i in fields) {
        let f = fields[i];
        if (fieldFilters[f])
            response[f] = fieldFilters[f](data[f]);
        else
            response[f] = data[f];
    }
    return response;
}

export const loadMyRequestsDashboard = async () => {
    let filter = {};
    filter["signature-request-document-dto"] = {};
    filter["signature-request-document-dto"]["draft"] = false;
    filter["signature-request-document-dto"]["initiatorId"] = whoami().username;
    filter['and'] = true;
    filter["order-by"] = "ID";
    filter["order-direction"] = "DESC";
    filter.offset = 0;
    filter.limit = 3;
    return await getData(filter).then(response => {
        return filterData(response)
    });
} 
export const loadIncommingRequestsDashboard = async () => {
    let filter = {};
    filter["signature-request-document-dto"] = {};
    filter["signature-request-document-dto"]["draft"] = false;
    filter['and'] = true;
    filter["order-by"] = "ID";
    filter["order-direction"] = "DESC";
    filter.offset = 0;
    filter.limit = 3;
    return await getData(filter).then(response => {
        return filterData(response)
    });
}

const getData = async (filter) => {
    let searchEndpoint = "signature-request/custom-search-document/"
    return await rest.request(getServiceUri() + searchEndpoint, "POST", filter);
}

const filterData = (defaultRows) => {
    const newRows = [];
    for (let i in defaultRows) {
        let peopleNumber = 0;
        let signedNumber = 0;
        let rejectedNumber = 0;
        let row = defaultRows[i];
        Object.keys(row.parties).forEach(k => {
            peopleNumber++
            if (row.parties[k].status === STATUS_SIGNED)
                signedNumber++
            if (row.parties[k].status === STATUS_REJECTED)
                rejectedNumber++
        })
        row.people = peopleNumber;
        if (signedNumber > 0)
            row.signed = signedNumber;
        if (rejectedNumber > 0)
            row.rejected = rejectedNumber;
        row.documents = row.documentNumber;
        newRows.push(row);
    };
    return newRows;
}